import type { PendingChangesAttributesName, ManagerGetCampaignModel } from '../model';

type PendingChangesMap = Record<PendingChangesAttributesName, boolean>;
type EmptyPendingChangesMap = Record<PendingChangesAttributesName, false>;
export type PendingChangesResult =
  | (PendingChangesMap & { appliesAt: string })
  | (EmptyPendingChangesMap & { appliesAt: null });

export function getPendingChanges(
  campaign: Pick<ManagerGetCampaignModel, 'status' | 'pendingChanges' | 'nextBillingStartAt'>,
  changesOnUi: Partial<PendingChangesMap>
): PendingChangesResult {
  const arePendingChangesApplicable =
    campaign.status === 'budgetReached' ||
    campaign.status === 'running' ||
    campaign.status === 'paused' ||
    campaign.status === 'deactivated';

  if (!arePendingChangesApplicable) {
    return {
      budget: false,
      zipCodes: false,
      running: false,
      pause: false,
      appliesAt: null,
      schedule: false,
      callCenterSchedule: false,
      minimalIncome: false,
    };
  }

  const beAttrs = campaign.pendingChanges?.attributes.map((item) => item.name) ?? [];

  const { budget, zipCodes, running, pause, minimalIncome } = changesOnUi;

  return {
    budget: budget || beAttrs.includes('budget'),
    zipCodes: zipCodes || beAttrs.includes('zipCodes'),
    running: running || beAttrs.includes('running'),
    pause: pause || beAttrs.includes('pause'),
    appliesAt: campaign.nextBillingStartAt,
    schedule: beAttrs.includes('schedule'),
    callCenterSchedule: beAttrs.includes('callCenterSchedule'),
    minimalIncome: minimalIncome || beAttrs.includes('minimalIncome'),
  };
}
